import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { TODO } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';

ProgramsCombosCreateDescriptionController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  'ApiService',
  'CalendarService',
  'ValidateService',
];

function ProgramsCombosCreateDescriptionController(
  $scope: IScope & { programsCombosCreateDescription: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  CalendarService: CalendarService,
  ValidateService: TODO
) {
  const ctrl = {
    isSubmitted: false,

    model: {
      name: '',
      shortDescription: '',
      description: '',
      emailConfirmation: '',
    } as TODO,
    next: '',
    combo: null as TODO | null,
    shortDescriptionMax: 300,
    shortDescriptionRemaining: 300,

    shortSummernoteConfig: {
      height: 100,
      focus: true,
      shortcuts: false,
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
      ],
    },

    longSummernoteConfig: {
      height: 200,
      focus: false,
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
      ],
    },

    emailSummernoteConfig: {
      height: 200,
      focus: false,
      shortcuts: false,
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
      ],
    },

    validators: [] as TODO[],

    init: function () {
      let titleLabel = 'Create Combo Description';

      $scope.$on('ProgramsCombosCreateController::save', ctrl.onSave);

      ctrl.initValidators();

      $scope.$on('$destroy', $scope.$watch('programsCreate.model.shortDescription', ctrl.onShortDescriptionUpdate));

      if ($state.params && $state.params.comboId) {
        ctrl.getCombo($state.params.comboId);
        titleLabel = 'Edit Combo Description';
      }

      const title = {
        title: titleLabel,
        buttonLeft: {
          label: 'Cancel',
          action: () => {
            $state.go('application.programs.combos.list');
          },
        },
        buttonRight: {
          label: 'Save & Close',
          action: () => {
            ctrl.complete(true);
          },
        },
      };

      $scope.$emit('Application::contentTitleChange', title);
    },

    onSave: function (e, data) {
      ctrl.next = data.state;
      ctrl.complete();
    },

    complete: function (close?: boolean) {
      const errorHandler = close ? ctrl.error.saveAndClose : ctrl.error.complete;
      const successHandler = close ? ctrl.success.saveAndClose : ctrl.success.complete;

      $scope.$emit('ProgramsCombosCreateController::reset');
      ctrl.isSubmitted = true;

      if (ctrl.isValid()) {
        if (ctrl.combo && ctrl.combo.id) {
          ApiService.combo.templates
            .update(ctrl.marshal.toJSON())
            .then((response) => successHandler(response))
            .catch((response) => errorHandler(response));
        } else {
          ApiService.combo.templates
            .create(ctrl.marshal.toJSON())
            .then((response) => successHandler(response))
            .catch((response) => errorHandler(response));
        }
      } else {
        $scope.$emit('ProgramsCombosCreateController::error', { message: 'Please correct the errors below.' });
      }
    },

    checkShortDescription: function () {
      if (ctrl.model.shortDescription) {
        ctrl.model.shortDescription = ctrl.model.shortDescription.replace(/[\s\n]+/g, ' ');
        if (ctrl.model.shortDescription > ctrl.shortDescriptionMax) {
          ctrl.model.shortDescription = ctrl.model.shortDescription.substr(0, ctrl.shortDescriptionMax);
        }
      } else {
        ctrl.model.shortDescription = '';
      }
      ctrl.shortDescriptionRemaining = ctrl.shortDescriptionMax - ctrl.model.shortDescription.length;
    },

    initValidators: function () {
      ctrl.validators = [
        {
          field: 'programs-combos-create-description-name',
          len: {
            message: 'Please enter a valid name',
            test: () => {
              return { value: ctrl.model.name };
            },
          },
        },
        {
          field: 'programs-combos-create-description-notify',
          equal: {
            message: 'Please enter valid email addresses',
            test: () => {
              let i = 0;
              let ii = 0;
              let validCount = 0;

              if (ctrl.model.emailNotify) {
                for (i = 0, ii = ctrl.model.emailNotify.length; i < ii; i++) {
                  if (ValidateService.validators.email(ctrl.model.emailNotify[i].email)) {
                    validCount++;
                  }
                }
              }

              // return ii === validCount;
              return [ii, validCount];
            },
          },
        },
      ];
    },

    isValid: function (field?: TODO) {
      let r = true;

      if (ctrl.isSubmitted) {
        if (typeof field === 'undefined') {
          r = ValidateService.validate(ctrl.validators);
        } else {
          r = ValidateService.check(ctrl.validators, field);
        }
      }
      return r;
    },

    getCombo: function (id) {
      ApiService.combo.templates
        .get(id)
        .then((response) => ctrl.success.getCombo(response))
        .catch((response) => ctrl.error.getCombo(response));
    },

    success: {
      init: function (response) {},

      getCombo: function (response) {
        ctrl.marshal.fromJSON(response.data.payload);
      },

      complete: function (response) {
        $state.go(ctrl.next, { comboId: response.data.payload.id });
      },
      saveAndClose: function (response) {
        $scope.$emit('ProgramsCombosCreateController::success', { message: 'Successfully Saved!' });
        $scope.$emit('ProgramsCombosCreateController::transition', { state: 'application.programs.combos.list' });
      },
    },

    error: {
      init: function (response) {},

      getCombo: function (response) {},

      complete: function (response) {
        $scope.$emit('ProgramsCombosCreateController::error', { message: response.data.error });
      },
      saveAndClose: function (response) {
        $scope.$emit('ProgramsCombosCreateController::error', { message: response.data.error });
      },
    },

    marshal: {
      fromJSON: function (json) {
        ctrl.model.name = json.name;
        ctrl.model.description = json.description;
        ctrl.model.shortDescription = json.shortDescription;
        ctrl.model.emailConfirmation = json.emailConfirmationMessage;
        ctrl.model.emailNotify = json.emailNotify;
        ctrl.combo = json;
      },

      toJSON: function () {
        if (ctrl.combo) {
          ctrl.combo.startTime = CalendarService.toISO8601(ctrl.combo.startTime);
          ctrl.combo.endTime = CalendarService.toISO8601(ctrl.combo.endTime);
          ctrl.combo.name = ctrl.model.name;
          ctrl.combo.description = ctrl.model.description;
          ctrl.combo.shortDescription = ctrl.model.shortDescription;
          ctrl.combo.emailConfirmationMessage = ctrl.model.emailConfirmation;
          ctrl.combo.emailNotify = ctrl.model.emailNotify;
        } else {
          ctrl.combo = {
            startTime: CalendarService.toISO8601(new Date()),
            endTime: CalendarService.toISO8601(new Date()),
            name: ctrl.model.name,
            description: ctrl.model.description,
            shortDescription: ctrl.model.shortDescription,
            emailConfirmationMessage: ctrl.model.emailConfirmation,
            emailNotify: ctrl.model.emailNotify,
          };
        }

        return ctrl.combo;
      },
    },

    onShortDescriptionUpdate: function (e, data) {
      ctrl.checkShortDescription();
    },

    getError: function (field) {
      return ValidateService.getError(field);
    },

    isValidEmailNotify: function (recipient) {
      return ValidateService.validators.email(recipient.email);
    },

    removeEmailNotifyRecipient: function (index) {
      if (ctrl.model.emailNotify instanceof Array && ctrl.model.emailNotify[index]) {
        ctrl.model.emailNotify.splice(index, 1);
      }
    },

    addEmailNotifyRecipient: function () {
      if (!(ctrl.model.emailNotify instanceof Array)) {
        ctrl.model.emailNotify = [];
      }
      ctrl.model.emailNotify.push({
        name: '',
        email: '',
      });
    },
  };

  $scope.programsCombosCreateDescription = ctrl;
  ctrl.init();
}

export const ProgramsCombosCreateDescriptionControllerModule = angular
  .module('acme.view.application.programs.combos.create.description.controllers', ['acme.common.service.api'])
  .controller('ProgramsCombosCreateDescriptionController', ProgramsCombosCreateDescriptionController).name;
